import type { RecursivePartial } from '#types/utils'
import type { AccountConfig } from '#types/config/pages/account'

export default {
  brandClasses: {
    navigation: 'py-6 <md:b-t',
  },
} satisfies RecursivePartial<AccountConfig>
